import { Labels } from '../../shared-components/global/labels.js';

Labels.set(
    'ui-cookie-consent',
    'mainTitle',
    'Mūsų slapukai – Jūsų pasirinkimai'
);
Labels.set('ui-cookie-consent', 'settingsTitle', 'Slapukų nustatymai');
Labels.set(
    'ui-cookie-consent',
    'mainInfo',
    '„Swedbank“ grupės {entitiesLink}, veikiančios {country} naudoja {cookiesLink} ar panašias technologijas, kurios yra būtinos šios svetainės veikimui. Taip pat naudojame slapukus, kuriuos galite pasirinkti, norėdami pagerinti ir suasmeninti savo patirtį:'
);
Labels.set(
    'ui-cookie-consent',
    'secondaryInfo',
    'Tvarkyti šių slapukų pasirinkimą galite paspausdami "Slapukų nustatymai". Savo sutikimą bet kada galite atšaukti mūsų puslapyje {usageLink}. Daugiau informacijos kaip mes naudojame slapukus rasite mūsų {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'settingsInfo',
    'Savo sutikimą bet kada galite atšaukti mūsų puslapyje {usageLink}. Daugiau informacijos kaip mes naudojame slapukus rasite mūsų {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'thirdPartyDisclaimer',
    'Šioje svetainėje naudojami trečiųjų šalių slapukai.'
);
Labels.set('ui-cookie-consent', 'accept', 'Patvirtinti visus slapukus');
Labels.set(
    'ui-cookie-consent',
    'decline',
    'Patvirtinti tik būtinuosius slapukus'
);
Labels.set('ui-cookie-consent', 'myCookies', 'Slapukų nustatymai');
Labels.set('ui-cookie-consent', 'saveChoice', 'Išsaugoti slapukų nustatymus');
Labels.set('ui-cookie-consent', {
    HELP_NECESSARY:
        'Būtinieji: būtini, kad svetainė veiktų sklandžiai ir saugiai, jų negalima išjungti. Užtikrina svarbias funkcijas, tokias kaip prisijungimas ir kalbos nustatymai.',
    HELP_ANALYTICAL:
        'Analitiniai: padeda mums suprasti, kaip naudotojai naudojasi mūsų svetaine, kokios funkcijos yra populiarios, kokios gali būti sudėtingos. Šiuos duomenis naudojame, kad patobulintume savo svetainę. Jei jų atsisakysite, tokia statistika nebus renkama.',
    HELP_TARGETING:
        'Rinkodaros: padeda pateikti tik jums aktualią informaciją apie mūsų produktus ir paslaugas. Jei jų atsisakysite, suasmenintas turinys jums nebus pateiktas.',
    HELP_FUNCTIONAL:
        'Funkciniai: pagerina jūsų naršymo patirtį. Be jų jums gali tekti pakartotinai įvesti informaciją, filtruoti turinį, daugiau slinkti turinį ir prarasti kitas naudingas funkcijas.',
});
Labels.set('ui-cookie-consent', {
    CATEGORY_NECESSARY: 'Būtinieji',
    CATEGORY_TARGETING: 'Rinkodaros',
    CATEGORY_ANALYTICAL: 'Analitiniai',
    CATEGORY_FUNCTIONAL: 'Funkciniai',
});
Labels.set('ui-cookie-consent', {
    COOKIE_TARGETING: 'Rinkodaros',
    COOKIE_ANALYTICAL: 'Analitiniai',
    COOKIE_FUNCTIONAL: 'Funkciniai',
});
Labels.set('ui-cookie-consent', 'EE', 'Estija');
Labels.set('ui-cookie-consent', 'LV', 'Latvija');
Labels.set('ui-cookie-consent', 'LT', 'Lietuvoje');
Labels.set('ui-cookie-consent', 'entities', 'įmonės');
Labels.set('ui-cookie-consent', 'cookies', 'slapukus');
Labels.set('ui-cookie-consent', 'language', 'Kalba');
Labels.set('ui-cookie-consent', 'usage', 'Slapukų naudojimas');
Labels.set('ui-cookie-consent', 'policyLinkLabel', 'Slapukų politikoje');
